import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import EmptyState from '../components/EmptyState';
import tryShorten from '../utils/urlShorten';
import whatsAppIcon from '../assets/icons/whatsapp.svg';
import axiosInstance from '../services/axios';
import ceremonyImage from '../assets/images/ceremony.png';

const CeremonyDetail = () => {
  const { slug } = useParams();
  const { i18n } = useTranslation();
  const [shortUrl, setShortUrl] = useState('');
  const [copied, setCopied] = useState(false);
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchCeremonyDetail = async () => {
      try {
        setLoading(true);
        const language = i18n.language === 'mr' ? 'Marathi' : 'English';
        const response = await axiosInstance.get('/ceremonies/', {
          params: { id: slug, language }
        });

        const apiData = response.data;
        console.log('Ceremony Detail API response:', apiData);

        if (apiData && apiData.length > 0) {
          const foundItem = apiData[0]; // First item from filtered response
          setItem({
            id: foundItem.id,
            slug: foundItem.id,
            imgSrc: foundItem.cover_image || ceremonyImage
          });
          setData({
            title: foundItem.title,
            description: foundItem.description || ''
          });
        }
      } catch (err) {
        console.error('Error fetching ceremony detail:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCeremonyDetail();
  }, [slug, i18n.language]);

  useEffect(() => {
    if (!item) return;
    const abs = `${window.location.origin}/ceremony/${item.slug}`;
    tryShorten(abs).then(setShortUrl).catch(() => setShortUrl(abs));
  }, [item]);

  if (loading) return <div className="p-6 text-center"><Spin size="large" /></div>;
  if (!item || !data) return <div className="p-6"><EmptyState description={i18n.language === 'en' ? 'Ceremony not found' : 'समारंभ सापडला नाही'} /></div>;

  const handleCopy = async () => {
    const link = shortUrl || `${window.location.origin}/ceremony/${item.slug}`;
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch { }
  };

  const handleShareWhatsApp = async () => {
    const abs = `${window.location.origin}/ceremony/${item.slug}`;
    const short = await tryShorten(abs);
    const message = `${data.title}\n\n${data.description}\n\n${short}`;
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, "_blank");
  };

  return (
    <div className="pb-12">

      {/* Page Title */}
      <div className="text-center mt-6 mb-8">
        <h1 className="text-4xl font-extrabold text-[#1f9c38] tracking-tight drop-shadow">
          {data.title}
        </h1>
        <div className="h-1 w-24 bg-[var(--color-primary)] mx-auto mt-3 rounded-full"></div>
      </div>

      {/* Card Container */}
      <div className="max-w-3xl mx-auto bg-white border rounded-2xl shadow-xl p-6">

        {/* Image */}
        <div className="w-full rounded-xl overflow-hidden shadow-md">
          <img
            src={item.imgSrc}
            alt={data.title}
            className="w-full h-96 object-cover transition-transform duration-500 hover:scale-105"
          />
        </div>

        {/* Description */}
        <p className="mt-6 text-gray-700 text-[16px] leading-relaxed font-medium">
          {data.description}
        </p>

        {/* Buttons */}
        <div className="mt-6 flex flex-wrap gap-4">
          <button
            onClick={handleShareWhatsApp}
            className="flex items-center gap-2 px-5 py-2.5 bg-[var(--color-primary)] text-white rounded-lg shadow hover:bg-[#18812f] transition"
          >
            <img loading="lazy" src={whatsAppIcon} alt="whatsapp" className="w-4 h-4" />
            Share on WhatsApp
          </button>

          <button
            onClick={handleCopy}
            className={`px-5 py-2.5 border rounded-lg shadow text-sm transition ${copied ? "bg-green-100 border-green-400" : "hover:bg-gray-100 border-gray-300"
              }`}
          >
            {copied ? "Copied ✓" : "Copy link"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CeremonyDetail;
